import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';
import { Languages, LonghaulReleaseServices, Service } from 'src/app/shared/models/enums.model';
import { Listing } from 'src/app/shared/models/listing.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { MyRequestsService } from 'src/app/shared/services/my-Requests.service';
import { ReportsService } from 'src/app/shared/services/reports.service';

@Component({
  selector: 'app-release-report',
  templateUrl: './release-report.component.html'
})
export class ReleaseReportComponent {
  //#region Properties & Variables
  public currentUser: User = new User();
  releaseFormCreators: User[] = [];
  userGroups: number[] = [];
  statusesList: any [] = [];
  isRleaseReportAdmin: boolean = false;
  serviceType = LonghaulReleaseServices;
  serviceTypeKeys = Object.keys(this.serviceType);
  creationDateFrom: string = "";
  creationDateTo: string= "";
  statusId: string = "";
  serviceTypeId: string = "";
  longhaulRequestNumber: string = "";
  requestNumber: string = ""
  rebateFileNumber: string = "";
  imo: string = "";
  vesselName: string = "";
  agentName: string = "";
  releaseFormCreatorEmail: string = "";
  refundDateFrom: string = "";
  refundDateTo: string = "";
  private collection: Listing;
  lang: string;
  pageSize = 15;
  private itemsMenu: MenuItem[] = [];
  sortBy: string = "";
  sortDir: string = "";
  exportngParametersUrl: string = "";
  responseObj: ResponseObject;
  isErrorMessage: Boolean = false;
  @ViewChild('ReleaseReport',{static: false}) gridView: GridViewComponent;
  HasMenu: boolean = true;
  InvalidDateMessage: any;
  creationDateFromFormatted: string;
  creationDateToFormatted: string;
  refundDateFromFormatted: string;
  refundDateToFormatted: string;
  hideExportButton: Boolean = false;
  showRefundFromDateGreaterThanRefundToDateMessage: boolean = false;
  showFromDateGreaterThanTodayDateMessage: boolean = false;
  showFromDateGreaterThanToDateMessage: boolean = false;

  //#endregion
  constructor(private etenderSrv: EtenderService, private route: Router,
    private myReportsService: ReportsService, private global: GlobalServices,
    private myRequestsService: MyRequestsService, private agentService: AgentService,
    private translate: TranslateService, private authenticationService: AuthenticationService,
    private router: Router, private localeService: BsLocaleService, private lookupService: LookupService,
    public datepipe: DatePipe, private longhaulserv: LongHaulService) {
      this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
      this.currentUser = this.authenticationService.currentUserValue;
      this.etenderSrv.GetUserGroups(this.currentUser.Email).subscribe(
        data => {
          this.userGroups = data.Data;
          if(this.userGroups != null)
          {
            if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_MeasurementCommittee ||
              ug == ETenderAdminTypes.SCAServices_EconomicCommittee ||
              ug == ETenderAdminTypes.SCAServices_RefundFirstReviewer ||
              ug == ETenderAdminTypes.SCAServices_RefundSecondReviewer ||
              ug == ETenderAdminTypes.SCAServices_RefundMeasurementManager ||
              ug == ETenderAdminTypes.SCAServices_RefundEunitGroup ||
              ug == ETenderAdminTypes.SCAServices_RefundDeputyManager ||
              ug == ETenderAdminTypes.SCAServices_RefundManager ||
              ug == ETenderAdminTypes.SCAServices_RefundMeasurementPrint ||
              ug == ETenderAdminTypes.SCAServices_RestudyReviewer ||
              ug == ETenderAdminTypes.SCAServices_RestudyManager ||
              ug == ETenderAdminTypes.SCAServices_RestudyEconomic ||
              ug == ETenderAdminTypes.SCAServices_RestudyEconomicApprove ||
              ug == ETenderAdminTypes.SCAServices_ReleaseFormCreator).length > 0) {
              this.isRleaseReportAdmin = true;
            }
          }

      if(!this.isRleaseReportAdmin)
        this.route.navigateByUrl('/workspace');
      },
      () => console.log('Something went wrong!!')
    );

    this.serviceTypeKeys = this.serviceTypeKeys.slice(this.serviceTypeKeys.length / 2);


  }

  async ngOnInit() {
    this.InvalidDateMessage = await this.translate.get('SHARED.InvalidDate').toPromise();

    this.currentUser = this.authenticationService.currentUserValue;
    enGbLocale.invalidDate = this.InvalidDateMessage;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    this.loadStatuses(30);
    this.loadReleaseFormCreators();
    this.loadSearchCriteria();
    this.loadReleaseReport();
  }

  loadStatuses(serviceId) {
    this.statusesList = [];
    this.myRequestsService.getMyRequestsStatusesLookups(serviceId).subscribe(
      response => this.statusesList.push(...response.Data.Statuses),
      () => console.log("Something went wrong!!"),
      () => console.log("Completed"),
    );
  }

  loadReleaseFormCreators() {
    this.longhaulserv.GetNextStepUsers('SCAServices_ReleaseFormCreator').subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          this.releaseFormCreators = resObj.Data;
        }
      }
    )
  }

  loadSearchCriteria() {
    if (this.global.ReleaseReportSearchCriteria.length > 0) {
      const criteria = this.global.ReleaseReportSearchCriteria[0];

      this.creationDateFrom = criteria.creationDateFrom;
      this.creationDateTo = criteria.creationDateTo;
      this.statusId = criteria.statusId;
      this.serviceTypeId = criteria.serviceTypeId;
      this.longhaulRequestNumber = criteria.longhaulRequestNumber;
      this.requestNumber = criteria.requestNumber;
      this.rebateFileNumber = criteria.rebateFileNumber;
      this.imo = criteria.imo;
      this.vesselName = criteria.vesselName;
      this.agentName = criteria.agentName;
      this.releaseFormCreatorEmail = criteria.releaseFormCreatorEmail;
      this.refundDateFrom = criteria.refundDateFrom;
      this.refundDateTo = criteria.refundDateTo;

      this.global.ReleaseReportSearchCriteria = [];
    }
  }

  loadReleaseReport() {
    this.storeSearchCriteria();

    this.creationDateFrom = this.creationDateFrom == null ? "" : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? "" : this.creationDateTo;
    this.refundDateFrom = this.refundDateFrom == null ? "" : this.refundDateFrom;
    this.refundDateTo = this.refundDateTo == null ? "" : this.refundDateTo;

    if (this.creationDateFrom.toString() != this.InvalidDateMessage &&
        this.creationDateTo.toString() != this.InvalidDateMessage) {

      this.global.isLoaderEnabled = true;

      this.creationDateFromFormatted = this.creationDateFrom == "" ? "" : this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
      this.creationDateToFormatted = this.creationDateTo == "" ? "" : this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
      this.refundDateFromFormatted = this.refundDateFrom == "" ? "" : this.datepipe.transform(this.refundDateFrom, 'MM/dd/yyyy');
      this.refundDateToFormatted = this.refundDateTo == "" ? "" : this.datepipe.transform(this.refundDateTo, 'MM/dd/yyyy');

      this.createExportingParametersUrl();

      this.myReportsService.getReleaseReport(
        0,
        this.pageSize,
        this.sortBy,
        this.sortDir,
        encodeURIComponent(this.agentName),
        this.longhaulRequestNumber,
        this.requestNumber,
        this.creationDateFromFormatted,
        this.creationDateToFormatted,
        this.statusId,
        this.rebateFileNumber,
        this.imo,
        encodeURIComponent(this.vesselName),
        this.releaseFormCreatorEmail,
        this.serviceTypeId,
        this.refundDateFromFormatted,
        this.refundDateToFormatted
      ).subscribe(
        res => {
          this.responseObj = res;
          if (!this.responseObj.Success) {
            this.isErrorMessage = true;
          }
          this.collection = res.Data;
          this.hideExportButton = res.Data.TotalNumber > 0 ? false : true;
        },
        err => console.error("Something went wrong!!"),
        () => this.loadCollectionCompleted()
      );
    }
  }

  loadCollectionCompleted() {
    this.loadItemsMenu();

    const url = "Report/GetReleaseReport?pageIndex={PAGEINDEX}"
      + "&pageSize=" + this.pageSize
      + "&sortBy=" + this.sortBy
      + "&sortDir=" + this.sortDir
      + "&language=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&agentName=" + encodeURIComponent(this.agentName)
      + "&longHaulRequestNumber=" + this.longhaulRequestNumber
      + "&requestNumber=" + this.requestNumber
      + "&submissionDateFrom=" + this.creationDateFromFormatted
      + "&submissionDateTo=" + this.creationDateToFormatted
      + "&statusId=" + this.statusId
      + "&rebateFileNumber=" + this.rebateFileNumber
      + "&imo=" + this.imo
      + "&vesselName=" + encodeURIComponent(this.vesselName)
      + "&releaseFormCreatorEmail=" + this.releaseFormCreatorEmail
      + "&serviceTypeId=" + this.serviceTypeId
      + "&refundDateFrom=" + this.refundDateFromFormatted
      + "&refundDateTo=" + this.refundDateToFormatted;

    this.gridView.loadGrid(
      this.collection,
      this.collection == null ? 0 : this.collection.TotalNumber,
      this.pageSize,
      url,
      "SHARED.REPORTS.RELEASE_OBJECT",
      this.itemsMenu,
      "",
      "",
      ""
    );

    this.global.isLoaderEnabled = false;
  }

  createExportingParametersUrl() {
    this.exportngParametersUrl = "&sortBy=" + this.sortBy
      + "&sortDir=" + this.sortDir
      + "&language=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&agentName=" + encodeURIComponent(this.agentName)
      + "&longHaulRequestNumber=" + this.longhaulRequestNumber
      + "&requestNumber=" + this.requestNumber
      + "&submissionDateFrom=" + this.creationDateFromFormatted
      + "&submissionDateTo=" + this.creationDateToFormatted
      + "&statusId=" + this.statusId
      + "&rebateFileNumber=" + this.rebateFileNumber
      + "&imo=" + this.imo
      + "&vesselName=" + encodeURIComponent(this.vesselName)
      + "&releaseFormCreatorEmail=" + this.releaseFormCreatorEmail
      + "&serviceTypeId=" + this.serviceTypeId
      + "&refundDateFrom=" + this.refundDateFromFormatted
      + "&refundDateTo=" + this.refundDateToFormatted;
  }


  storeSearchCriteria() {
    this.global.ReleaseReportSearchCriteria = [];
    this.global.ReleaseReportSearchCriteria.push({
      creationDateFrom: this.creationDateFrom,
      creationDateTo: this.creationDateTo,
      statusId: this.statusId,
      serviceTypeId: this.serviceTypeId,
      longhaulRequestNumber: this.longhaulRequestNumber,
      requestNumber: this.requestNumber,
      rebateFileNumber: this.rebateFileNumber,
      imo: this.imo,
      vesselName: this.vesselName,
      agentName: this.agentName,
      releaseFormCreatorEmail: this.releaseFormCreatorEmail,
      refundDateFrom: this.refundDateFrom,
      refundDateTo: this.refundDateTo
    });
  }

  resetFilters() {
    this.creationDateFrom = "";
    this.creationDateTo = "";
    this.agentName = "";
    this.longhaulRequestNumber = "";
    this.requestNumber = "";
    this.statusId = "";
    this.rebateFileNumber = "";
    this.imo = "";
    this.vesselName = "";
    this.releaseFormCreatorEmail = "";
    this.serviceTypeId = "";
    this.refundDateFrom = "";
    this.refundDateTo = "";
    this.creationDateFromFormatted = "";
    this.creationDateToFormatted = "";
    this.refundDateFromFormatted = "";
    this.refundDateToFormatted = "";
    this.statusesList = [];
    this.hideExportButton = false;
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.showRefundFromDateGreaterThanRefundToDateMessage = false;

    this.loadReleaseReport();
  }

  getReleaseReportData() {

    this.removeAllValidationMessages()

    if (this.isCreationFromDateGreaterThanCreationToDate()) {
      this.showFromDateGreaterThanToDateMessage = true;
      return;
    }

    if (this.isCreationFromDateGreaterThanToday()) {
      this.showFromDateGreaterThanTodayDateMessage = true;
      return;
    }

    if (this.isRefundFromDateGreaterThanRefundToDate()) {
      this.showRefundFromDateGreaterThanRefundToDateMessage = true;
      return;
    }

    this.loadReleaseReport();
  }

  removeAllValidationMessages() {
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.showRefundFromDateGreaterThanRefundToDateMessage = false;
  }

  isCreationFromDateGreaterThanCreationToDate(): boolean {
    if (this.creationDateFrom != "" && this.creationDateTo != "") {
      return new Date(this.creationDateFrom) > new Date(this.creationDateTo);
    }
    return false;
  }

  isCreationFromDateGreaterThanToday(): boolean {
    if (this.creationDateFrom != "") {
      return new Date(this.creationDateFrom) > new Date();
    }
    return false;
  }

  isRefundFromDateGreaterThanRefundToDate(): boolean {
    if (this.refundDateFrom != "" && this.refundDateTo != "") {
      return new Date(this.refundDateFrom) > new Date(this.refundDateTo);
    }
    return false;
  }

  onServiceChange(event: any) {
    this.loadStatuses(event.target.value)
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Request History";
    this.itemsMenu[1].TitleAr = "تاريخ الطلب";
    if (this.currentUser.IsAdmin) {
      this.itemsMenu[2] = new MenuItem();
      this.itemsMenu[2].Title = "Workflow Status";
      this.itemsMenu[2].TitleAr = "حالة مسار العمل";
    }
  }

}

export class MenuItem {
  Title: string;
  TitleAr: string;
};
